// import { formatMoney } from '@shopify/theme-currency';

Shopify.formatMoney = function (cents, format) {
  let value = '';
  const placeholderRegex = /{{\s*(\w+)\s*}}/;
  const formatString = format || this.money_format;

  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);

    cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      console.warn('Something going wrong with converting');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class ShippingProgressBar extends HTMLElement {
  constructor() {
    super();
    // Get static data from dataset
    this.priceGoal = parseFloat(this.dataset.priceGoal);
    this.titleGoalRiched = this.dataset.titleGoalRiched;
    this.titleGoalMayRiched = this.dataset.titleGoalMayRiched;
    this.title = this.dataset.title;
    this.subtitle = this.dataset.subtitle;
    this.productData = JSON.parse(document.querySelector('#product-json').textContent);
    this.moneyFormat = this.dataset.moneyFormat;
    this.quantityInput = document.querySelector('#Quantity');

    // Initialize dynamic data
    this.priceCart = 0;
    this.priceCartFormatted = '';
    this.priceDifference = 0;
    this.pricePredicted = 0;
    this.pricePredictedFormatted = '';
    this.progressBarValue = 0;

    // Subscribe to the cart-total-price-updated event
    this.cartDrawer = document.querySelector('#cart-drawer');
    this.boundHandleCartUpdate = this.handleCartUpdate.bind(this); // bind the function here
    this.cartDrawer.addEventListener('cart-total-price-updated', this.boundHandleCartUpdate);
  }

  connectedCallback() {
    this.handleCartUpdate();
    // Calculate initial values
    this.calculateValues();
    // Render the component
    this.render();
    // Listen for variant updates
    document.addEventListener('variant:update', this.handleVariantUpdate.bind(this));
    document.addEventListener('input:quantity', () => {
      this.handleVariantUpdate();
    });
  }

  disconnectedCallback() {
    // Unsubscribing from an event when a component is removed from the DOM
    this.cartDrawer.removeEventListener('cart-total-price-updated', this.boundHandleCartUpdate);
  }

  handleCartUpdate() {
    // Updating Cart Details
    this.priceCart = parseFloat(this.cartDrawer.dataset.cartSubtotal);
    this.priceCartFormatted = Shopify.formatMoney(this.priceCart);

    // Recalculating values ​and rendering the component
    this.calculateValues();
    this.render();
  }

  handleVariantUpdate(event) {
    // Recalculate values on variant update
    this.calculateValues();
  }

  calculateValues() {
    // Get variant ID from URL
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    // Get variant price from productData
    let variantPrice = 0;

    // Get quantity from input
    let quantity = 1;

    if (this.quantityInput) {
      quantity = parseInt(this.quantityInput.value, 10);
    }

    let foundVariant = null;

    if (variantId && this.productData) {
      foundVariant = this.productData.variants.find((v) => String(v.id) === variantId);
    } else if (this.productData) {
      foundVariant = this.productData.variants[0];
    } else {
      foundVariant = null;
    }

    if (foundVariant) {
      variantPrice = parseFloat(foundVariant.price);
    }

    variantPrice *= quantity;

    // Calculate predicted price, difference, and progress
    this.pricePredicted = this.priceCart + variantPrice;
    this.pricePredictedFormatted = Shopify.formatMoney(this.pricePredicted);

    this.priceDifference = this.priceGoal - this.pricePredicted;
    this.priceDifferenceFormatted = Shopify.formatMoney(this.priceDifference);

    this.progressBarValue = (this.pricePredicted / this.priceGoal) * 100;

    this.render();
  }

  render() {
    this.renderTitle();
    this.renderProgressBar();
  }

  renderTitle() {
    const titleContainer = this.querySelector('[data-element="title-container"]');
    const subtitleContainer = this.querySelector('[data-element="subtitle-container"]');

    // Clear the title container
    titleContainer.innerHTML = '';
    subtitleContainer.innerHTML = '';
    let titleText = '';
    let subtitleText = '';

    // Determine the title text based on the calculated values
    if (this.priceCart >= this.priceGoal) {
      titleText = this.titleGoalRiched;
    } else if (this.priceDifference <= 0) {
      titleText = this.titleGoalMayRiched;
    } else {
      titleText = this.title.replace('{{ price_difference }}', this.priceDifferenceFormatted);
    }

    subtitleText = this.subtitle.replace('{{ price_cart }}', this.priceCartFormatted);
    subtitleText = subtitleText.replace('{{ price_predicted }}', this.pricePredictedFormatted);

    // Create and append the title element
    const titleElement = document.createElement('h2');
    const subtitleElement = document.createElement('span');

    subtitleContainer.classList.add('text-sm', 'text-gray-500');
    titleElement.textContent = titleText;
    titleContainer.appendChild(titleElement);
    subtitleElement.textContent = subtitleText;
    subtitleContainer.appendChild(subtitleElement);
  }

  renderProgressBar() {
    const progressBarInner = this.querySelector('[role="progressbar"] div');

    progressBarInner.style.right = `calc(100% - ${this.progressBarValue}%)`;
  }
}

customElements.define('shipping-progress-bar', ShippingProgressBar);
